import {Box} from '@customink/pigment-react';
import React from 'react';
import sharedBoxStyles from './sharedStyles';

const BoxCardsView = ({children}) => {
  return <Box sx={sharedBoxStyles}>{children}</Box>;
};

export default BoxCardsView;
